<!-- eslint-disable -->
<template lang="pug">
    svg(:width="elemWidth" height="21" fill="none" xmlns="http://www.w3.org/2000/svg")
        line(y1="20" :x2="elemWidth - 1" y2="20" stroke="black")
        line(:x1="elemWidth - 1" :x2="elemWidth - 1" y2="20" stroke="black")
        line(x1="0.5" x2="0.5" y2="20" stroke="black")
</template>

<script>
/*eslint-disable*/

export default {
    props: {
        elemWidth: {
            type: Number,
            default: 121,
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
